import { ComplaintsType } from "@/src/data/types";
import { DataTable } from "../../ui/data-table";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { columns } from "./columns";

interface ComplaintsProps {
  data: ComplaintsType[];
}

export const ComplaintsData: React.FC<ComplaintsProps> = ({ data }) => {
  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Messages (${data.length})`}
          description="Gestion des messages "
        />
      </div>
      <Separator />
      <DataTable searchKey="name" columns={columns} data={data} />
    </>
  );
};
